import React, { useEffect } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import {I18nFormatter} from "../../utils/I18n/I18n";
import PropTypes from 'prop-types';

const AggregationInfoChart = ({
    item: propItem,
    loading: propLoading,
    init: propInit,
    t
}) => {
    const staticNames = t?.chart || {};

    useEffect(() => {
        propInit();
    }, [propInit]);

    return (
        <div className="chart_container">
            <div className="chart">
                <span className="title">{staticNames.ngr}:</span>
                <span className="value">{
                    propItem ? I18nFormatter.currency(
                        propItem.aggregationInfo.ngr.amount,
                        propItem.aggregationInfo.ngr.currency
                    ) : null
                }</span>
            </div>
            <div className="chart">
                <span className="title">RS:</span>
                <span className="value">{
                    propItem ? I18nFormatter.currency(
                        propItem.aggregationInfo.rs.amount,
                        propItem.aggregationInfo.rs.currency
                    ) : null
                }</span>
            </div>
        </div>
    );
};

AggregationInfoChart.propTypes = {
    item: PropTypes.object,
    loading: PropTypes.bool,
    init: PropTypes.func,
    t: PropTypes.object
};

AggregationInfoChart.defaultProps = {
    item: null,
    loading: false,
    init: () => {}
};

export default withTranslation(AggregationInfoChart);
